/**
 * API base URL - always use the production API
 */

function getApiBaseUrl() {
  return 'https://api.desatagawiti.com';
}

const API_BASE_URL = getApiBaseUrl();

console.log('API Base URL:', API_BASE_URL);

/**
 * Convert relative image paths to absolute backend URLs
 * @param {string} imagePath - Image URL or path (e.g., "/uploads/news/filename.png" or full URL)
 * @returns {string} - Absolute image URL
 */
function getImageUrl(imagePath) {
  if (!imagePath) {
    return '';
  }

  // If already an absolute URL with http/https
  if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
    // Replace localhost:3000 with correct API URL if present
    if (imagePath.includes('localhost:3000')) {
      return imagePath.replace('http://localhost:3000', API_BASE_URL);
    }
    // If it already has api.desatagawiti.com or other domain, keep as-is
    return imagePath;
  }

  // If relative path, prepend API base URL
  if (imagePath.startsWith('/')) {
    return `${API_BASE_URL}${imagePath}`;
  }

  // Otherwise assume it's a relative path from /uploads
  return `${API_BASE_URL}/${imagePath}`;
}

export { getApiBaseUrl, getImageUrl, API_BASE_URL };
